import React from 'react';
import { Box, Typography } from '@material-ui/core';
import { useCommentsContext } from '@components/CaseDetails/CommentsSection/CommentsContext/CommentsContext';
import { makeStyles } from '@material-ui/core/styles';
import NotificationImportantOutlinedIcon from '@material-ui/icons/NotificationImportantOutlined';
import { DEFAULT_SELECTION_ALL } from '@utilities/constants';

const useStyles = makeStyles((theme) => ({
	root: {
		display: 'flex',
		width: '100%',
	},
	text: {
		'gridArea': 'noCommentsText',
		'paddingLeft': theme.spacing(3),

		'&.MuiTypography-root': {
			fontSize: '1.25rem',
		},
	},
	icon: {
		color: 'inherit',
		gridArea: 'icon',
	},
	filterText: {
		fontWeight: 400,
		fontSize: '1.125rem',
		gridArea: 'filterText',
		paddingLeft: theme.spacing(3),
	},
	textWrapper: {
		'display': 'grid',
		'gridTemplateColumns': '1fr 15fr',
		'gridTemplateRows': 'auto',
		'gridTemplateAreas': `
			"icon noCommentsText"
			". filterText"
		`,
		'rowGap': theme.spacing(1),

		'&.MuiBox-root': {
			padding: theme.spacing(5, 3, 3, 3),
		},
	},
}));

export const NoCommentsMessage: React.FC = () => {
	const classes = useStyles();
	const { comments, nonFilteredComments, typeFilter } = useCommentsContext();

	if (comments?.length > 0) { return null; }

	return (
		<Box className={classes.root}>
			<Box className={classes.textWrapper}>
				<NotificationImportantOutlinedIcon className={classes.icon} />
				<Typography variant="h2" className={classes.text}>
					No Comments
				</Typography>
				{typeFilter !== DEFAULT_SELECTION_ALL && nonFilteredComments?.length > 0 && (
					<Typography variant="body1" className={classes.filterText}>
						Select another Comment Type or select All.
					</Typography>
				)}
			</Box>
		</Box>
	);
};
